import { faList, faMap } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, IconButton, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { URL_LIST_VIEW, URL_MAP_VIEW } from "src/router/routes";

const SwitchView = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const { schema } = useParams<{ schema: string }>();

    const isLocationMap = location.pathname === `/${schema}${URL_MAP_VIEW}`;

    const switchDetails = {
        icon: isLocationMap ? faList : faMap,
        text: isLocationMap ? t("list") : t("map"),
        targetUrl: isLocationMap
            ? `/${schema}${URL_LIST_VIEW}`
            : `/${schema}${URL_MAP_VIEW}`,
    };

    const handleNavigation = () => {
        navigate(switchDetails.targetUrl);
    };

    return (
        <IconButton disableRipple color="primary" onClick={handleNavigation}>
            <Box display="flex" alignItems="center" gap={1}>
                <FontAwesomeIcon icon={switchDetails.icon} />
                <Typography>{switchDetails.text}</Typography>
            </Box>
        </IconButton>
    );
};

export default SwitchView;
